import { render, staticRenderFns } from "./TemplateUpload.vue?vue&type=template&id=0d5c442a"
import script from "./TemplateUpload.vue?vue&type=script&lang=js"
export * from "./TemplateUpload.vue?vue&type=script&lang=js"
import style0 from "./TemplateUpload.vue?vue&type=style&index=0&id=0d5c442a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports